import {
  plus354lvypr4cqa1 as plus,
  ThemeDerivation3kcl449hwgd5y as ThemeDerivation,
  Semanticpmpmvt7fldq2 as Semantic,
  SelectedSemantic_getInstance3ef29ujazc52t as SelectedSemantic_getInstance,
  UnselectedSemantic_getInstancexnnq5hq6ryv2 as UnselectedSemantic_getInstance,
  DangerSemantic_getInstance3i0xmw7we3iku as DangerSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from './AppColors.mjs';
import { Companion_getInstancenv8qpb0wanrh as Companion_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Paint.mjs';
import {
  get_px8ok5q0jdway2 as get_px,
  get_dp28ag147e4p5cz as get_dp,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../components/nav/AppDimensions.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { mapOf1xd03cq9cnmy8 as mapOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import {
  Constant5dc3leeorpdb as Constant,
  PerCorner27xb33zgvi5gv as PerCorner,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/CornerRadii.mjs';
import { mapOf2zpbbmyqk8xpf as mapOf_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var WithoutPaddingClass;
function WithoutPadding() {
  if (WithoutPaddingClass === VOID) {
    class $ {
      hd1(theme) {
        return theme.fb1(SectionSemantic_getInstance()).gb1_1.bb1_1;
      }
    }
    protoOf($).abf = plus;
    initMetadataForObject($, 'WithoutPadding', VOID, VOID, [ThemeDerivation()]);
    WithoutPaddingClass = $;
  }
  return WithoutPaddingClass;
}
var WithoutPadding_instance;
function WithoutPadding_getInstance() {
  return WithoutPadding_instance;
}
var SectionSemanticClass;
function SectionSemantic() {
  if (SectionSemanticClass === VOID) {
    class $ extends Semantic() {
      static zjr() {
        SectionSemantic_instance = null;
        var $this = this.dd1('sctn');
        SectionSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        var currentIsDark = theme.qb0_1.db2().rcz().ad0_1 < 0.95;
        return this.jd1(theme, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, currentIsDark ? Companion_getInstance().taz_1 : AppColors_getInstance().hfz_1.bga_1);
      }
      toString() {
        return 'SectionSemantic';
      }
      hashCode() {
        return -643258023;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SectionSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'SectionSemantic');
    SectionSemanticClass = $;
  }
  return SectionSemanticClass;
}
var SectionSemantic_instance;
function SectionSemantic_getInstance() {
  if (SectionSemantic_instance === VOID)
    SectionSemantic().zjr();
  return SectionSemantic_instance;
}
function get_section(_this__u8e3s4) {
  return _this__u8e3s4.jbb(SectionSemantic_getInstance());
}
var LightSectionClass;
function LightSection() {
  if (LightSectionClass === VOID) {
    class $ extends Semantic() {
      static bjs() {
        LightSection_instance = null;
        var $this = this.dd1('lgtsctn');
        LightSection_instance = $this;
        return $this;
      }
      ed1(theme) {
        var backIsWhite = theme.qb0_1.db2().bb3() > 0.99;
        return this.jd1(theme, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, backIsWhite ? AppColors_getInstance().hfz_1.cga_1 : Companion_getInstance().taz_1);
      }
      toString() {
        return 'LightSection';
      }
      hashCode() {
        return 1683663393;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LightSection()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'LightSection');
    LightSectionClass = $;
  }
  return LightSectionClass;
}
var LightSection_instance;
function LightSection_getInstance() {
  if (LightSection_instance === VOID)
    LightSection().bjs();
  return LightSection_instance;
}
function get_lightSection(_this__u8e3s4) {
  return _this__u8e3s4.jbb(LightSection_getInstance());
}
var DarkSectionClass;
function DarkSection() {
  if (DarkSectionClass === VOID) {
    class $ extends Semantic() {
      static djs() {
        DarkSection_instance = null;
        var $this = this.dd1('drksctn');
        DarkSection_instance = $this;
        return $this;
      }
      ed1(theme) {
        var currentIsDark = theme.qb0_1.db2().rcz().ad0_1 < 0.95;
        return this.jd1(theme, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, currentIsDark ? Companion_getInstance().taz_1 : AppColors_getInstance().hfz_1.aga_1);
      }
      toString() {
        return 'DarkSection';
      }
      hashCode() {
        return 699923229;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DarkSection()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'DarkSection');
    DarkSectionClass = $;
  }
  return DarkSectionClass;
}
var DarkSection_instance;
function DarkSection_getInstance() {
  if (DarkSection_instance === VOID)
    DarkSection().djs();
  return DarkSection_instance;
}
function get_darkSection(_this__u8e3s4) {
  return _this__u8e3s4.jbb(DarkSection_getInstance());
}
function PurpleSelectButtons$default$lambda($this$to, it) {
  var tmp0_background = AppColors_getInstance().efz_1.zg9_1;
  var tmp1_foreground = Companion_getInstance().taz_1;
  var tmp2_outlineWidth = get_px(0);
  var tmp3_outline = Companion_getInstance().saz_1;
  return $this$to.jd1(it, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_foreground, VOID, tmp3_outline, tmp2_outlineWidth, VOID, tmp0_background);
}
function PurpleSelectButtons$default$lambda_0($this$to, it) {
  var tmp0_foreground = AppColors_getInstance().mfz_1.yg9_1;
  var tmp1_background = Companion_getInstance().taz_1;
  var tmp2_outlineWidth = get_AppDimensions().qg2_1;
  var tmp3_outline = AppColors_getInstance().efz_1.zg9_1;
  return $this$to.jd1(it, VOID, VOID, VOID, VOID, VOID, VOID, tmp0_foreground, VOID, tmp3_outline, tmp2_outlineWidth, VOID, tmp1_background);
}
var PurpleSelectButtonsClass;
function PurpleSelectButtons() {
  if (PurpleSelectButtonsClass === VOID) {
    class $ extends Semantic() {
      static fjs() {
        PurpleSelectButtons_instance = null;
        var $this = this.dd1('prpslct');
        PurpleSelectButtons_instance = $this;
        return $this;
      }
      ed1(theme) {
        var tmp = SelectedSemantic_getInstance();
        var tmp_0 = to(tmp, PurpleSelectButtons$default$lambda);
        var tmp_1 = UnselectedSemantic_getInstance();
        return this.gd1(theme, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, mapOf([tmp_0, to(tmp_1, PurpleSelectButtons$default$lambda_0)]));
      }
      toString() {
        return 'PurpleSelectButtons';
      }
      hashCode() {
        return -1847591145;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PurpleSelectButtons()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'PurpleSelectButtons');
    PurpleSelectButtonsClass = $;
  }
  return PurpleSelectButtonsClass;
}
var PurpleSelectButtons_instance;
function PurpleSelectButtons_getInstance() {
  if (PurpleSelectButtons_instance === VOID)
    PurpleSelectButtons().fjs();
  return PurpleSelectButtons_instance;
}
function MessageSemantic$default$lambda($this$to, it) {
  var tmp0_background = Companion_getInstance().taz_1;
  var tmp1_foreground = Companion_getInstance().vaz_1;
  var tmp2_outline = AppColors_getInstance().jfz_1.zg9_1;
  var tmp3_outlineWidth = get_px(1);
  var tmp4_cornerRadii = new (Constant())(get_dp(10));
  var tmp5_iconOverride = AppColors_getInstance().jfz_1.zg9_1;
  return $this$to.jd1(it, VOID, VOID, VOID, tmp4_cornerRadii, VOID, VOID, tmp1_foreground, tmp5_iconOverride, tmp2_outline, tmp3_outlineWidth, VOID, tmp0_background);
}
var MessageSemanticClass;
function MessageSemantic() {
  if (MessageSemanticClass === VOID) {
    class $ extends Semantic() {
      static gjs(mine, colors) {
        var $this = this.dd1((mine ? 'my' : 'other') + 'msg_' + colors.xg9_1);
        $this.qgt_1 = mine;
        $this.rgt_1 = colors;
        return $this;
      }
      static sgt(mine) {
        return this.gjs(mine, AppColors_getInstance().efz_1);
      }
      ed1(theme) {
        var newBack = this.qgt_1 ? this.rgt_1.zg9_1 : AppColors_getInstance().hfz_1.bga_1;
        var newFront = this.qgt_1 ? Companion_getInstance().taz_1 : theme.lb0_1;
        var tmp0_cornerRadii = new (PerCorner())(get_dp(10), true, true, this.qgt_1, !this.qgt_1);
        var tmp = DangerSemantic_getInstance();
        var tmp1_derivations = mapOf_0(to(tmp, MessageSemantic$default$lambda));
        return this.jd1(theme, VOID, VOID, VOID, tmp0_cornerRadii, VOID, VOID, newFront, VOID, VOID, VOID, VOID, newBack, VOID, VOID, VOID, VOID, VOID, tmp1_derivations);
      }
      toString() {
        return 'MessageSemantic(mine=' + this.qgt_1 + ', colors=' + this.rgt_1.toString() + ')';
      }
      hashCode() {
        var result = getBooleanHashCode(this.qgt_1);
        result = imul(result, 31) + this.rgt_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MessageSemantic()))
          return false;
        if (!(this.qgt_1 === other.qgt_1))
          return false;
        if (!this.rgt_1.equals(other.rgt_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'MessageSemantic');
    MessageSemanticClass = $;
  }
  return MessageSemanticClass;
}
var HorizontallyPaddedSemanticClass;
function HorizontallyPaddedSemantic() {
  if (HorizontallyPaddedSemanticClass === VOID) {
    class $ extends Semantic() {
      static ijs() {
        HorizontallyPaddedSemantic_instance = null;
        var $this = this.dd1('fhpad');
        HorizontallyPaddedSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        var tmp0_padding = theme.kb0_1.id0(VOID, get_px(0), VOID, get_px(0));
        return this.md1(theme, false, VOID, VOID, VOID, VOID, tmp0_padding).db1_1;
      }
      toString() {
        return 'HorizontallyPaddedSemantic';
      }
      hashCode() {
        return -667494087;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof HorizontallyPaddedSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'HorizontallyPaddedSemantic');
    HorizontallyPaddedSemanticClass = $;
  }
  return HorizontallyPaddedSemanticClass;
}
var HorizontallyPaddedSemantic_instance;
function HorizontallyPaddedSemantic_getInstance() {
  if (HorizontallyPaddedSemantic_instance === VOID)
    HorizontallyPaddedSemantic().ijs();
  return HorizontallyPaddedSemantic_instance;
}
//region block: init
WithoutPadding_instance = new (WithoutPadding())();
//endregion
//region block: exports
export {
  MessageSemantic as MessageSemantic26vy91vxbjwf0,
  get_darkSection as get_darkSection25mxxvxk8ts3b,
  get_lightSection as get_lightSection4cpu8okr0w14,
  get_section as get_section1qyzr1npzel2z,
  DarkSection_getInstance as DarkSection_getInstance2gsqmxxo07g1v,
  HorizontallyPaddedSemantic_getInstance as HorizontallyPaddedSemantic_getInstance8jqirrp2bab1,
  LightSection_getInstance as LightSection_getInstance1p9fz392synu9,
  PurpleSelectButtons_getInstance as PurpleSelectButtons_getInstance1ga9xxb87mrwe,
  WithoutPadding_instance as WithoutPadding_instance322j5y2aaszpe,
  SectionSemantic_getInstance as SectionSemantic_getInstance27qbv8tkwzf0w,
};
//endregion

//# sourceMappingURL=sections.mjs.map
